export const userConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
    
    LOGOUT: 'USERS_LOGOUT', 
    UPDATE_TABLE_DATA: 'UPDATE_TABLE_DATA',
    RESET_TABLE_DATA: 'RESET_TABLE_DATA',
    SHOW_LOADING_SPINNER: 'SHOW_LOADING_SPINNER',
    HIDE_LOADING_SPINNER: 'HIDE_LOADING_SPINNER',
    SET_BLOCKING_STATE: 'SET_BLOCKING_STATE',
    SET_DELETE_STATE:'SET_DELETE_STATE',
    FILE_DOWNLOAD_DATA: 'FILE_DOWNLOAD_DATA',
    SET_CREATE_STATE:'SET_CREATE_STATE',
    UPDATE_AUDITOR_DATA:'UPDATE_AUDITOR_DATA',


    //Role Defined
EDOC_TME_ADMIN:"EDOC TME ADMIN",
EDOC_TME_USER:"EDOC TME USER",
EDOC_TRD_USER:"EDOC TRD USER",
EDOC_NMSC_USER:"EDOC NMSC USER",
EDOC_NMSC_TRD_USER:"EDOC NMSC TRD USER",
EDOC_FORWARDER_USER:"EDOC FORWARDER USER",
EDOC_DEPOT_USER:"EDOC DEPOT USER",
EDOC_INVOICE_ADMIN:"EDOC INVOICE ADMIN",
EDOC_INVOICE_AUDITOR:"EDOC INVOICE AUDITOR"
};